module.exports = __webpack_public_path__ + "static/media/icn-check-white-16px.31c41042.svg";